import IResult from 'src/dataModel/IResult';
import IReq from './IReq';
import IResp from './IResp';
import Urls from 'src/config/Urls';
import http from 'src/utils/ajaxUtils';

/**
 * 接口描述
 * @param param 参数，IReq类型
 */
async function getOsPageList(param: IReq): Promise<IResult<IResp>> {
  const resp = await http.get(Urls.getOsList, param);
  return resp;
}

export default getOsPageList;


// WEBPACK FOOTER //
// ./src/api/netelement/getOsPageList/index.ts